var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

import React, { Component } from 'react';
import { Button, Form, FormGroup, FormFeedback, Label, Input, InputGroup, InputGroupAddon, InputGroupText, CustomInput, Modal, ModalHeader, ModalBody, ModalFooter, Popover, PopoverHeader, PopoverBody } from 'reactstrap';
import { Card, CardTitle, CardText, CardBody, Row, Col, Container } from 'reactstrap';

import Select from 'react-select';

var logdown = require('logdown');
var logger = logdown('rx-forms-rx-select', { prefixColor: '#2e7d32' });

var RXSelect = function (_Component) {
    _inherits(RXSelect, _Component);

    function RXSelect(props) {
        _classCallCheck(this, RXSelect);

        var _this = _possibleConstructorReturn(this, _Component.call(this, props));

        logger.log('in *select start*');
        var options = _this.props.options === undefined ? [] : _this.props.options;
        _this.state = { invalid: false, borderColor: "lightGray", globalValue: "", options: options };
        _this.localValue = "";
        _this.customStyle = { control: function control(styles) {
                return _extends({}, styles, { backgroundColor: 'white', borderColor: _this.state.borderColor });
            } };
        return _this;
    }

    RXSelect.prototype.componentDidUpdate = function componentDidUpdate(prevProps) {
        if (this.props.invalid != prevProps.invalid) {
            logger.log('log in change invalid: ' + this.props.invalid);
            if (this.props.invalid) {
                this.setState({ invalid: this.props.invalid, borderColor: "#dc3545" });
            } else {
                this.setState({ invalid: this.props.invalid, borderColor: "lightGray" });
            }
        }
        if (this.props.value != prevProps.value) {
            logger.log('in componentDidUpdate for value: ' + this.props.value);
            if (Object.prototype.hasOwnProperty.call(this.props.value, 'options')) {
                this.setState({ globalValue: this.props.value, localValue: this.props.value.value, options: this.props.value.options });
            } else {
                this.setState({ globalValue: this.props.value, localValue: this.props.value.value });
            }
        }
    };

    RXSelect.prototype.render = function render() {
        var _this2 = this;

        var _props = this.props,
            onChange = _props.onChange,
            onBlur = _props.onBlur,
            value = _props.value,
            options = _props.options,
            other = _objectWithoutProperties(_props, ['onChange', 'onBlur', 'value', 'options']);

        var localOnChange = function localOnChange(newValue) {
            if (newValue === undefined || newValue === null) {
                _this2.localValue = "";
                _this2.setState({ localValue: "", globalValue: { label: "", value: 0 } }, function () {
                    logger.log('after setState');
                });
            } else {
                logger.log('in localOnChange before onBlur with ' + JSON.stringify(newValue));
                _this2.localValue = newValue.value;
                _this2.setState({ localValue: newValue.value, globalValue: newValue }, function () {
                    logger.log('after setState');
                });
            }
            onChange({ target: { type: "select", value: newValue, id: other.id } });
            // onBlur({target: {type: "select", value: newValue.value, id: other.id}})
        };

        var localOnBlur = function localOnBlur(event) {
            logger.log('in localOnBlur for ' + _this2.state.localValue);
            onBlur({ target: { type: "select", value: _this2.localValue, id: other.id } });
        };

        return React.createElement(
            React.Fragment,
            null,
            React.createElement(Select, _extends({ styles: this.customStyle, onChange: localOnChange, onBlur: localOnBlur, value: this.state.globalValue, options: this.state.options }, other, { isClearable: true })),
            this.state.invalid && React.createElement(
                'div',
                { className: 'text-danger small' },
                this.props.feedbackMessage
            )
        );
    };

    return RXSelect;
}(Component);

export default RXSelect;